import { Task_Lead } from "../../../_core/classes/task_lead";

export class TaskLeadEditConfiguration {

    data: Task_Lead | null = null;
    taskOid: number | null = null;
    selectedLead : any = null;

    constructor() { }

    public static create = () => new TaskLeadEditConfiguration();

    setData(data: Task_Lead | null) {
        this.data = data;
        return this;
    }

    setTaskOid(taskOid: number | null) {
        this.taskOid = taskOid;
        return this;
    }

    setSelectedLead(selectedLead: any) {
        this.selectedLead = selectedLead;
        return this;
    }

}